import axios from "axios";

const BASE_URL = "https://gg-api.nationtonation.ca/api/shipping";

export interface ShipmentItem {
  product_id: number;
  variant_id?: number | null;
  quantity: number;
}

export interface CreateShipmentPayload {
  tracking_number: string;
  carrier?: string;
  notes?: string;
  items: ShipmentItem[];
}

export interface Shipment {
  id: number;
  order_id: number;
  tracking_number: string;
  carrier?: string;
  notes?: string;
  shipped_at: string;
  created_at: string;
  updated_at: string;
  items: ShipmentItem[];
}

export interface FulfillmentData {
  order: any;
  items: Array<{
    id: number;
    product_id: number;
    variant_id?: number;
    product_name: string;
    variant_name?: string;
    order_quantity: number;
    remaining_quantity: number;
  }>;
  shipments: Shipment[];
  fulfillmentStatus: string;
}

export const createShipment = async (orderId: number, payload: CreateShipmentPayload): Promise<Shipment> => {
  try {
    const response = await axios.post(`${BASE_URL}/orders/${orderId}/shipments`, payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data.shipment;
  } catch (error) {
    console.error("Error creating shipment:", error);
    throw error;
  }
};

export const fetchFulfillmentData = async (orderId: number): Promise<FulfillmentData> => {
  try {
    const response = await axios.get(`${BASE_URL}/orders/${orderId}/fulfillment-data`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching fulfillment data:", error);
    throw error;
  }
};
export const fetchShipmentsByOrder = async (orderId: number): Promise<Shipment[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/orders/${orderId}/shipments`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching shipments for order:", error);
    throw error;
  }
};

export const fetchShipmentDetails = async (shipmentId: number): Promise<Shipment> => {
  try {
    const response = await axios.get(`${BASE_URL}/shipments/${shipmentId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching shipment details:", error);
    throw error;
  }
};
